import styled from 'styled-components';

export const Sidebar = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    overflow: hidden;
`;

export const SidebarScroll = styled.div`
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: var(--space-3, 12px);
`;

export const SidebarTitle = styled.h3`
    margin: 0 0 10px 0;
    font-size: 12px;
    font-weight: 600;
    color: var(--color-muted-foreground, #6b7280);
    text-transform: uppercase;
    letter-spacing: 0.04em;
`;

export const SidebarSectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-2, 8px);
    margin: 14px 0 6px 0;
    padding: 0 4px 0 12px;
`;

export const SidebarSectionLabelGroup = styled.div`
    display: flex;
    align-items: baseline;
    gap: var(--space-1, 4px);
    min-width: 0;
`;

export const SidebarSectionLabel = styled.p`
    margin: 0;
    font-size: 11px;
    font-weight: 600;
    color: var(--color-muted-foreground, #9ca3af);
    text-transform: uppercase;
    letter-spacing: 0.04em;
`;

export const SidebarSectionCount = styled.span`
    font-size: 11px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: var(--color-muted-foreground, #9ca3af);
`;

export const SortButton = styled.button`
    appearance: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    border: none;
    border-radius: var(--radius-sm, 6px);
    padding: 4px 6px;
    background: transparent;
    color: var(--color-muted-foreground, #6b7280);
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
        background: var(--color-muted, #f8fafc);
        color: var(--color-foreground, #111827);
    }

    & > svg {
        flex-shrink: 0;
    }
`;

export const SearchContainer = styled.div`
    position: relative;
    width: 100%;
    margin: 0 0 var(--space-2, 8px) 0;

    input {
        border-radius: 9999px;
        padding-left: 2rem;
        height: 32px;
        font-size: 13px;
        background-color: var(--color-muted, #f8fafc);
        border-color: var(--color-border, #e5e7eb);

        &:focus {
            background-color: var(--color-background, white);
        }

        &::placeholder {
            color: var(--color-muted-foreground, #9ca3af);
        }
    }
`;

export const SearchIcon = styled.div`
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--color-muted-foreground, #9ca3af);
    pointer-events: none;
    z-index: 1;

    svg {
        width: 14px;
        height: 14px;
    }
`;

export const SidebarList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const SidebarEmptyState = styled.p`
    margin: var(--space-2, 8px) 0 0 0;
    padding: 0 12px;
    font-size: 12px;
    color: var(--color-muted-foreground, #9ca3af);
`;

export const SidebarItemButton = styled.button<{ $isActive: boolean; $isEnabled: boolean }>`
    width: 100%;
    border: none;
    border-radius: 8px;
    padding: 10px 12px;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    white-space: nowrap;
    cursor: ${({ $isEnabled }) => ($isEnabled ? 'pointer' : 'not-allowed')};
    font-size: 13px;
    font-weight: 500;
    opacity: ${({ $isEnabled }) => ($isEnabled ? 1 : 0.55)};
    color: ${({ $isActive }) =>
        $isActive ? 'var(--color-primary, #2563eb)' : 'var(--color-foreground, #111827)'};
    background: ${({ $isActive }) => ($isActive ? 'var(--color-blue-50, #eff6ff)' : 'transparent')};

    &:hover {
        background: ${({ $isActive, $isEnabled }) => {
            if (!$isEnabled) {
                return 'transparent';
            }
            return $isActive ? 'var(--color-blue-50, #eff6ff)' : 'var(--color-muted, #f8fafc)';
        }};
    }

    & > svg {
        flex-shrink: 0;
    }
`;

export const SidebarItemLabel = styled.span`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const SidebarItemHint = styled.span`
    flex-shrink: 0;
    margin-left: auto;
    font-size: 11px;
    font-weight: 400;
    font-style: italic;
    color: var(--color-muted-foreground, #9ca3af);
`;

export const SidebarItemAmount = styled.span`
    flex-shrink: 0;
    margin-left: auto;
    font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace);
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    font-variant-numeric: tabular-nums;
    color: var(--color-slate-600, #475569);
`;

export const SidebarFooter = styled.div`
    flex-shrink: 0;
    padding: var(--space-3, 12px);
    border-top: 1px solid var(--color-border, #e5e7eb);
    background: var(--color-background, white);
`;

export const AddCustomProviderButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border: 1px dashed var(--color-border, #e5e7eb);
    border-radius: var(--radius-md, 8px);
    padding: 10px 12px;
    background: transparent;
    color: var(--color-muted-foreground, #6b7280);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
        background: var(--color-muted, #f8fafc);
        color: var(--color-foreground, #111827);
    }
`;
